import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { EditionShell } from "../components/dnh/feed/EditionShell";
import { NewsFeed } from "../components/dnh/feed/NewsFeed";

export default function Country() {
  const { slug } = useParams();
  const [scope, setScope] = useState(null);
  const name = scope?.country?.name || slug.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase());
  return <EditionShell title={name} activeNav="Explore" testId="country-page" actions={<Link className="dnh-outline-button" to={`/today?country=${encodeURIComponent(slug)}&summary=1`} data-testid="country-today-summary">Today's overview</Link>}>
    <NewsFeed key={slug} country={slug} title={name} onScope={setScope} />
  </EditionShell>;
}
